import React from 'react';
import  {createRoot} from 'react-dom/client';
import  { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from '../screens/App/containers/App';
import ProviderWithRouter from './ProviderWithRouter';
import ApolloProviderWrapper from './ApolloProviderWrapper';


const root = createRoot(document.getElementById('root'));
root.render(<div>
    <BrowserRouter>
        <ProviderWithRouter isDevelopment={false}>
            <ApolloProviderWrapper>
                <Routes>
                    <Route path="/*" element={<App />} />
                </Routes>
            </ApolloProviderWrapper>
        </ProviderWithRouter>
    </BrowserRouter>
</div>)
